import flatpickr from "flatpickr";
import "flatpickr/dist/flatpickr.min.css";
import { Japanese } from "flatpickr/dist/l10n/ja.js";

$(function () {
    const datepicker = document.getElementById("datepicker");
    if (!datepicker) {
        return;
    }

    // 初期表示は時間セレクトボックスを非活性化
    const dateInput = $(".js-visit-date-input");
    const timeSelect = $(".js-visit-time-select");
    if (dateInput.val() === "") {
        timeSelect.attr("disabled", "disabled");
    }

    // 選択可能な年月日を取得
    const parsedAvailableTimes = JSON.parse(datepicker.getAttribute("data-available-date-time"));
    const enabledDates = parsedAvailableTimes.map((item) => item.date);

    // 見学可能日時が存在しない場合、見学申し込みできないのでアラートでお知らせする
    if (enabledDates.length === 0) {
        alert("現在は見学申し込みを受け付けておりません。\n施設にお問い合わせください。");
    }

    // 表示する上限の日付を取得
    const maxDate = new Date();
    maxDate.setDate(maxDate.getDate() + 90);

    // 選択できる初めの日付を取得
    const visitInquiryAvailableDaysFrom = document.getElementById("visitInquiryAvailableDaysFrom");
    if (!visitInquiryAvailableDaysFrom) {
        return;
    }
    const visitInquiryAvailableDaysFromValue = visitInquiryAvailableDaysFrom.value;
    const currentDate = new Date();
    const firstAvailableDate = new Date(currentDate);
    firstAvailableDate.setDate(currentDate.getDate() + parseInt(visitInquiryAvailableDaysFromValue));
    const formattedFirstAvailableDate = firstAvailableDate.toISOString().split("T")[0]; // 日付と時刻を区切って年月日だけ取得

    const availableDateTime = {
        getTimesForDate: function (data, targetDate) {
            const entry = data.find((entry) => entry.date === targetDate);
            return entry !== undefined ? entry.times : [];
        },
        handleDateChange: function (selectedDates) {
            // 年月日が削除されたなど値がない場合
            if (dateInput.val() === "") {
                timeSelect.empty();
                timeSelect.append($("<option>", { value: "", text: "時間" }));
                timeSelect.attr("disabled", "disabled");
                return;
            }
            timeSelect.removeAttr("disabled");
            const selectedDate = selectedDates[0];
            const formattedDate = flatpickr.formatDate(selectedDate, "Y-m-d");
            const availableTimes = availableDateTime.getTimesForDate(parsedAvailableTimes, formattedDate);
            availableDateTime.populateTimeOptions(availableTimes);
        },
        populateTimeOptions: function (availableTimes) {
            const timeSelect = $(".js-visit-time-select");
            timeSelect.empty();
            timeSelect.append($("<option>", { value: "", text: "時間" }));
            availableTimes.forEach((time) => {
                timeSelect.append($("<option>", { value: time, text: time }));
            });
        }
    };

    flatpickr("#datepicker", {
        locale: Japanese,
        dateFormat: "Y/m/d",
        minDate: formattedFirstAvailableDate,
        maxDate: maxDate,
        enable: enabledDates,
        static: true,
        onChange: availableDateTime.handleDateChange
    });
});
